import store from '../store';

export function simple(object) {
    let func = (state = {}, action) => {
        if (func.object[action.type]) {
            return func.object[action.type](state, action);
        } else {
            return state;
        }
    };

    func.object = object;

    return func;
}

export function combine(reducers) {
    return (state, action) => reducers.reduce(
        (nextState, f) => f(nextState, action),
        state
    );
}
